import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slide from './Slide';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import isArray from 'lodash/isArray';
import kebabCase from 'lodash/kebabCase';
import toString from 'lodash/toString';
import {
    getLeadFormTriggerCodeForNcr,
    getNCRLeadFormTriggerCodeBasedOnOccasion,
    setNCRLeadFormTriggerCode,
} from '../../../../../../util/leadFormUtility';
import { getCurrentPage } from '../../../../../../util/vmCookieHandler';

class SlidesPostEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSlide: {},
            selectedValues: [],
            isNextBtnVisible: true,
            isPrevBtnVisible: true,
            isSkipButtonVisible: true,
            isLastBtn: false,
            currentIndex: 0,
            leadForm: {},
            slideLength: 0,
            qtext: '',
        };
    }

    componentDidMount() {
        if (!isEmpty(this.props.leadFormData)) {
            this.setState(
                {
                    leadForm: this.props.leadFormData,
                    currentSlide: this.props.leadFormData.slides[0],
                    slideLength: this.props.leadFormData.slides.length,
                },
                () => {
                    this.setButtonState(this.state.currentIndex);
                }
            );
        }
    }
    componentDidUpdate(prevProps) {
        // ✅ NEW BLOCK - jab leadFormData baad mein aaye empty state mein
        if (
            !isEqual(prevProps.leadFormData, this.props.leadFormData) &&
            !isEmpty(this.props.leadFormData) &&
            isEmpty(this.state.leadForm)
        ) {
            this.setState(
                {
                    leadForm: this.props.leadFormData,
                    currentSlide: this.props.leadFormData.slides[0],
                    slideLength: this.props.leadFormData.slides.length,
                },
                () => {
                    this.setButtonState(0);
                }
            );
        }
    
        // PURANA BLOCK - as it is
        if (
            this.props.newLeadFormData &&
            !isEqual(prevProps.newLeadFormData._id, this.props.newLeadFormData._id)
        ) {
            let leadForm = this.state.leadForm;
            leadForm.slides = leadForm.slides.filter(
                (item, index) => index <= this.state.currentIndex
            );
            leadForm.slides = leadForm.slides.concat(this.props.newLeadFormData.slides);
    
            this.setState(
                {
                    leadForm: leadForm,
                    slideLength: leadForm.slides.length,
                },
                () => {
                    this.setButtonState(this.state.currentIndex + 1);
                }
            );
        }
    }

    showMessage = (msg, msgtype) => {
        this.props.notify(msg, msgtype);
    };

    setButtonState = (index) => {
        let isPrevBtnVisble = this.state.leadForm.slides[index].isPrevBtnVisible;
        let isSkipButtonVisible = this.state.leadForm.slides[index].isSkipButtonVisible;
        let isNextBtnVisible = index <= this.state.slideLength - 1;
        let isLastBtn = index === this.state.slideLength - 1;
        this.setState({
            currentSlide: this.state.leadForm.slides[index],
            currentIndex: index,
            isNextBtnVisible: isNextBtnVisible,
            isPrevBtnVisible: isPrevBtnVisble,
            isSkipButtonVisible: isSkipButtonVisible,
            isLastBtn: isLastBtn,
        });
    };
    getOccasionCityCode = () => {
        let event = this.getEventDetails();
        return `new-${kebabCase(event.city)}-${kebabCase(event.occasion)}`;
    };

    handleSkipButtonClick = (index) => {
        if (index == this.state.leadForm.slides.length - 1) {
            this.finalSubmit();
        } else {
            this.setButtonState(index + 1);
        }
    };

    handleUpdateEvent = () => {
        let event = this.getEventDetails(false);
        this.props.saveToEvent(event, false);
    };

    handleNextClick = (index) => {
        let validatation = this.validateCurrentSlide(this.state.currentSlide);
        // setNCRLeadFormTriggerCode(this.state.currentSlide, this.props.selectedVenue,this.props.pageSource,this.props.leadFormTriggerCode,this.props.leadFormMode)
        if (!validatation.isValid) {
            this.props.notify(validatation.elements[0].errorMessage, 2);
        } else {
            let elements = this.state.currentSlide.elements;
            if (elements && isArray(elements) && elements.length > 0) {
                let ncrLeadFormTriggerCode = getLeadFormTriggerCodeForNcr(
                    this.props.selectedVenue,
                    this.props.pageSource,
                    getCurrentPage(),
                    this.props.leadFormMode
                );

                if (ncrLeadFormTriggerCode && ncrLeadFormTriggerCode !== '') {
                    this.props.createSuperEvent({
                        event_name: `${ncrLeadFormTriggerCode}-${elements[0].analyticsTriggerName}`,
                        action_name: 'next-slide',
                        feature_name: 'lead-form',
                        segment_name: 'post-otp-slide',
                    });
                    this.props.createSuperEvent({
                        event_name: `${ncrLeadFormTriggerCode}-${elements[0].analyticsTriggerName}-${this.props.leadFormTriggerCode}`,
                        action_name: 'next-slide',
                        feature_name: 'lead-form',
                        segment_name: 'post-otp-slide',
                    });
                }

                this.props.createSuperEvent({
                    event_name: `${this.props.pageSource || 'ncr'}-${
                        elements[0].analyticsTriggerName
                    }`,
                    action_name: 'next-slide',
                    feature_name: 'lead-form',
                    segment_name: 'pre-otp-slide',
                });
                this.props.createSuperEvent({
                    event_name: `${this.props.pageSource || 'ncr'}-${
                        elements[0].analyticsTriggerName
                    }-${this.props.leadFormTriggerCode}`,
                    action_name: 'next-slide',
                    feature_name: 'lead-form',
                    segment_name: 'pre-otp-slide',
                });
            }
            const eventDetails = this.getEventDetails();
            if (this.state.currentSlide.isTriggerSlide) {
                this.finalSubmit();
            } else {
                this.handleUpdateEvent();
                this.setButtonState(index + 1);
            }
        }
    };

    validateCurrentSlide = (currentSlide) => {
        let result = {
            isValid: true,
        };
        let requiredElements = currentSlide.elements.filter((item) => item.isRequired);
        if (requiredElements && requiredElements.length > 0) {
            let inValidElements = requiredElements.filter((item) => !this.validateElement(item));
            if (inValidElements && inValidElements.length !== 0) {
                result.elements = inValidElements;
                result.isValid = false;
            }
            return result;
        } else {
            return result;
        }
    };

    validateElement = (element) => {
        let isValid = false;
        if (element.elementType === 'radio') {
            let array = element.options.filter((item) => !!item.isSelected);
            isValid = array.length > 0;
        } else if (element.elementType === 'checkbox') {
            isValid = element.selectedOptions?.length > 0;
        } else if (
            element.elementType === 'checkbox' ||
            element.elementType === 'multikey-checkbox'
        ) {
            isValid = element.selectedOptions?.length > 0;
        } else if (element.elementType === 'date') {
            isValid = !!element.selectedValue;
        } else if (element.elementType === 'text') {
            isValid = !!element.selectedValue;
        }
        return isValid;
    };

    handleBackClick = (index) => {
        if (index < 1) {
            this.props.close();
        } else {
            this.setButtonState(index - 1);
        }
    };

    handleOptionSelect = (slideId, elementId, optionId, optionValue) => {
        let leadForm = this.state.leadForm;
    
        leadForm.slides = leadForm.slides.map((slide) => {
            if (slide._id === slideId) {
                slide.elements = slide.elements.map((element) => {
                    if (element._id === elementId) {
                        let selectedIndex = 0;
                        element.options =
                            element.options &&
                            element.options.length > 0 &&
                            element.options.map((option, index) => {
                                option.isSelected =
                                    toString(option.value) === toString(optionValue);
                                if (option.isSelected) {
                                    selectedIndex = index;
                                }
                                return option;
                            });
                        let option = element.options[0];
                        element.options[0] = element.options[selectedIndex];
                        element.options[selectedIndex] = option;
                    }
                    return element;
                });
                return slide;
            }
            return slide;
        });
    
        const currentIndex = this.state.currentIndex;
        const currentSlide = leadForm.slides[currentIndex];
        const isLastSlide = currentIndex === leadForm.slides.length - 1;
    
        this.setState({ leadForm: leadForm }, () => {
            if (currentSlide.isTriggerSlide || isLastSlide) {
                this.finalSubmit();
            } else {
                this.setButtonState(currentIndex + 1);
            }
        });
    };

    handleMultiOptionSelect = (slideId, elementId, optionId, optionValue) => {
        let leadForm = { ...this.state.leadForm };
        leadForm.slides = leadForm.slides.map((slide) => {
            let foundOption = false;
            if (slide._id === slideId) {
                slide.elements = slide.elements.map((element) => {
                    if (element._id === elementId) {
                        element.options = element.options.map((option) => {
                            if (option.value === optionValue) {
                                foundOption = true;

                                option.isSelected = !option.isSelected;
                                if (option.isSelected) {
                                    element.selectedOptions.push(option);
                                } else {
                                    element.selectedOptions = element.selectedOptions.filter(
                                        (item) => item.value !== optionValue
                                    );
                                }
                            }
                            return option;
                        });
                        if (!foundOption) {
                            element.selectedOptions = element.selectedOptions.filter(
                                (item) => item.value !== optionValue
                            );
                        }
                    }
                    return element;
                });
            }
            return slide;
        });

        this.setState({
            ...this.state,
            leadForm: leadForm,
        });
    };

    handleDateSelect = (slideId, elementId, optionValue) => {
        let leadForm = this.state.leadForm;
        leadForm.slides = leadForm.slides.map((slide) => {
            if (slide._id === slideId) {
                slide.elements = slide.elements.map((element) => {
                    if (element._id === elementId) {
                        element.selectedValue = optionValue;
                    }
                    return element;
                });
            }
            return slide;
        });

        this.setState({ leadForm: leadForm }, () => {
            this.handleNextClick(this.state.currentIndex);
        });
    };

    handleTextOptionFocus = (value) => {};

    handleTextOptionSelect = (slideId, elementId, optionValue) => {
        let leadForm = this.state.leadForm;
        leadForm.slides = leadForm.slides.map((slide) => {
            if (slide._id === slideId) {
                slide.elements = slide.elements.map((element) => {
                    if (element._id === elementId) {
                        element.selectedValue = optionValue;
                    }
                    return element;
                });
            }
            return slide;
        });
        this.setState({ leadForm: leadForm });
    };

    notifyToUser = (message) => {};

    finalSubmit = () => {
        let event = this.getEventDetails();
        this.props.saveToEvent(event);
        // this.props.close();
    };

    getEventDetails = (isFinalSlide = true) => {
        let event = {};
        this.state.leadForm.slides.forEach((slideItem) => {
            slideItem.elements.forEach((elementItem) => {
                if(elementItem.keys && elementItem.keys.length>0){
                    elementItem.keys.forEach((key,index)=>{
                        event[key] = this.getSelectedValueFromElement(elementItem,key)
                    })

                }else{
                    event[elementItem.keyName] = this.getSelectedValueFromElement(elementItem);
                }
            });
        });
        event.isLeadFormCompleted = isFinalSlide;
        return event;
    };

    getSelectedValueFromElement = (element,targetKey) => {
        if (element.elementType === 'radio') {
            return element.options.filter((item) => !!item.isSelected).map((item) => item.value)[0];
        } else if (element.elementType === 'date') {
            return element.selectedValue;
        } else if (element.elementType === 'text') {
            return element.selectedValue;
        } else if (element.elementType === 'checkbox') {
            return element.selectedOptions.map((item) => item.value);
        } else if (element.elementType === 'multikey-checkbox') {
            return element.selectedOptions.filter((item) => element.keys[item.targetKey] == targetKey).map((item)=> item.value);
        }
    };

    handleSearchLocalities = async (qtext, element, slideId, elementId) => {
        let newOptions = await this.props.fetchLocalitiesOptionBasedOnEvent(
            qtext,
            element.selectedOptions
        );

        let leadForm = this.state.leadForm;
        leadForm.slides = leadForm.slides.map((slide) => {
            if (slide._id === slideId) {
                slide.elements = slide.elements.map((element) => {
                    if (element._id === elementId) {
                        element.options = newOptions;
                    }
                    return element;
                });
            }
            return slide;
        });
        this.setState({
            ...this.state,
            leadForm: leadForm,
        });
    };
    handleOptionSearch = async (qtext, element, slideId, elementId) => {
        try {
            this.setState({ qtext: qtext });
            if (element.onSearchFunction && element.onSearchFunction !== '') {
                switch (element.onSearchFunction) {
                    case 'search_locality': {
                        await this.handleSearchLocalities(qtext, element, slideId, elementId);
                        return;
                    }
                    default:
                        console.warn('Unhandled onSearchFunction:', element.onSearchFunction);
                }
            }
        } catch (error) {
            console.error('Error handling option search:', error);
        }
    };

    render() {
        return (
            <Slide
                elements={this.state.currentSlide.elements}
                questionText={this.state.currentSlide.questionText}
                handleOptionSelect={this.handleOptionSelect}
                slideId={this.state.currentSlide._id}
                handleBackAndNext={this.handleBackAndNext}
                handleNextClick={this.handleNextClick}
                handleBackClick={this.handleBackClick}
                handleSkipButtonClick={this.handleSkipButtonClick}
                isLastBtn={this.state.isLastBtn}
                isTriggerSlide={this.state.currentSlide.isTriggerSlide}
                isNextBtnVisible={this.state.isNextBtnVisible}
                isPrevBtnVisible={this.state.isPrevBtnVisible}
                isSkipButtonVisible={this.state.isSkipButtonVisible}
                currentIndex={this.state.currentIndex}
                amplitudeEventName={this.state.currentSlide.targetId}
                handleMultiOptionSelect={this.handleMultiOptionSelect}
                handleDateSelect={this.handleDateSelect}
                handleTextOptionSelect={this.handleTextOptionSelect}
                isLoadingLeadForm={this.props.isLoadingLeadForm}
                isPlanningEvent={this.props.isPlanningEvent}
                handleTextOptionFocus={this.handleTextOptionFocus}
                handleOptionSearch={this.handleOptionSearch}
                qtext={this.state.qtext}
                countryCodeDict={this.props.countryCodeDict}
                nation={this.props.nation}
            />
        );
    }
}

export default SlidesPostEvent;
